"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayIn = void 0;
class ReplayIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return ReplayIn.attributeTypeMap;
    }
}
exports.ReplayIn = ReplayIn;
ReplayIn.discriminator = undefined;
ReplayIn.attributeTypeMap = [
    {
        "name": "since",
        "baseName": "since",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "until",
        "baseName": "until",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=ReplayIn.js.map